
export function  formatToIndianRupees(number) {
  if (number === null || number === undefined || Number.isNaN(Number(number))) return '—';
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0,
  }).format(number).replace("₹", "₹ ");
}

